export const FETCH_CATEGORIES_REQUEST = 'category/FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'category/FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'category/FETCH_CATEGORIES_FAILURE';
